"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MENU : TITLE : STYLES --------------- ++++++++++ */


var _default = {
  menutitle: {
    background: '#eee',
    padding: (0, _index.pxToEm)(10),
    display: function display(props) {
      return props.hideTitle ? 'none' : 'block';
    },
    '& h2': {
      color: _index.theme.color.supporting.dark.swatch,
      fontSize: (0, _index.pxToEm)(16),
      fontWeight: 'normal',
      marginBottom: '0'
    }
  }
};
exports.default = _default;